var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"loading"},[_c('video',{attrs:{"src":"/img/loading.mp4","autoplay":"","loop":"","muted":""},domProps:{"muted":true}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }